export default "__VITE_ASSET__DIJyKdYH__"